import routes from '@routes';
import { CacheProps, fetchApi } from '../../../fetch';

interface StoreComplaintsProps extends CacheProps {
  requestData: {
    type_id: string,
    order_id: string,
    title: string,
    description: string,
    image: string| null
  },
}

const storeComplaintsApi = ({ requestData, ...rest }: StoreComplaintsProps) => {
  return fetchApi({
    method: 'POST',
    URL: routes['api.client.complaints'],
    payload: requestData,
    withToken: true,
    ...rest,
  });
};

export default storeComplaintsApi;
